import { Assignment, AssignmentForm } from '@components-domain/education';
import { EntityConfig } from "@components-fabric";
import { getAssignmentValidationSchema } from '../../components-domain/education-domain/assignments/schema';

export const assignmentEntityConfig: EntityConfig<any> = {
  id: "assignment",
  name: "Assignment",
  schema: getAssignmentValidationSchema(),
  empty: {
    title: "",
    description: "",
    state: "ACTIVE",
    createdDate: new Date(Date.now()),
    modifiedDate: new Date(Date.now()),
    // lecturers: [],
    // dateRange: {
    //   startDate: new Date(Date.now()),
    //   endDate: new Date(Date.now()),
    //},
  },
  form: AssignmentForm,
  endpoints: "/courses/:courseId/assignments"
}
